import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import SEO from "./SEO";

const hasSupabase = !!(process.env.REACT_APP_SUPABASE_URL && process.env.REACT_APP_SUPABASE_ANON_KEY);

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!hasSupabase) return;
    setLoading(true);
    const { data, error: signError } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (signError) {
      setError(signError.message || "Pogrešan e-mail ili lozinka.");
      return;
    }
    if (data?.session) {
      const u = data.user;
      localStorage.setItem("travelina_admin_auth", "true");
      localStorage.setItem("travelina_admin_user", JSON.stringify({ email: u?.email, name: u?.email }));
      navigate("/admin");
    }
  };

  if (!hasSupabase) {
    return (
      <div className="admin-login-page">
        <SEO title="Admin – TraveLina" noindex={true} />
        <div className="admin-login-card">
          <h1>Admin</h1>
          <p className="admin-login-muted">
            Prijava je moguća samo putem Supabasea. U korijenu projekta dodaj u <code>.env</code> datoteke varijable{" "}
            <code>REACT_APP_SUPABASE_URL</code> i <code>REACT_APP_SUPABASE_ANON_KEY</code>, zatim ponovno pokreni
            razvojni poslužitelj.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-login-page">
      <SEO title="Admin prijava - TraveLina" noindex={true} />
      <div className="admin-login-card">
        <h1>Admin prijava</h1>
        <p className="admin-login-sub">Prijavi se računom iz Supabase Auth (e-mail / lozinka).</p>
        <form onSubmit={handleSubmit}>
          <div className="admin-login-field">
            <label htmlFor="admin-email">E-mail</label>
            <input
              id="admin-email"
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
              required
              autoComplete="email"
            />
          </div>
          <div className="admin-login-field">
            <label htmlFor="admin-password">Lozinka</label>
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
              required
              autoComplete="current-password"
            />
          </div>
          {error && <p className="admin-login-error">{error}</p>}
          <button type="submit" className="admin-login-submit" disabled={loading}>
            {loading ? "Prijava…" : "Prijava"}
          </button>
        </form>
      </div>
    </div>
  );
}
